// export const baseURL = "http://localhost:8000/";
import common from "../Store/common";
import "../config";
export const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_WEB_SITE
    : `//${window.location.host}/url/`;
// export const baseURL = "http://192.168.100.46:8000/";
// export const baseURL = "/url/";
// export const baseURL = window.location.origin+":8000/";
// export const baseURL = "https://co2rap.com/url/";
// export const baseURL = "http://79.133.37.189:8000/";
//
export const loginAPI = baseURL + "login";
export const logoutAPI = baseURL + "logout";
export const signupAPI = baseURL + "signup"; //
export const signupAPIWithExcel = baseURL + "signupWithExcel"; //
export const surveyInfo = baseURL + "survey-section-info/";
export const verifyOtp = baseURL + "reset-password";

const API = (url) => `${baseURL}${url}`;

export const deleteNotification = (id) =>
  baseURL + `notification-remove?id=${id}`;

export const getDataQuality = baseURL + "get-data-quality";

export const notificationList = () => baseURL + `get-notification`;

export const getAssetList = baseURL + "asset-list/";

export const getActivityLogAPI = baseURL + "activity-log/";
export const getOnlineTracker = baseURL + "online-checker";
export const getGroupReportsAPI = (
  selectionType,
  level,
  year,
  company,
  monthIndex
) =>
  baseURL +
  `group_report?selectionType=${selectionType}&level=${level}&year=${year}&company=${company}&monthIndex=${
    monthIndex ? monthIndex : undefined
  }`;

export const userListApi = baseURL + "get-all-user";
// export const exportUser = (condition) =>
//   baseURL +
//   `export-users?active=${condition?.active}&inactive=${condition?.inactive}`;
export const exportUser = (condition) =>
  baseURL + `export-users?checkedStatus=${condition}`;
export const editUserApi = baseURL + "edit-user";
export const updatePasswordApi = baseURL + "update-password";
export const deleteUserApi = (id) => baseURL + `remove-user/${id}`;
export const imageUrl = baseURL + "upload/building/";
export const noImageUrl = baseURL + "upload/building/no_image.png";
export const baseURLImage = baseURL.slice(0, -1);

export const verifyOTP = baseURL + "verify-otp";
export const resendOTP = baseURL + "resent-otp";
export const verifyEmail = baseURL + "forgot-password";
export const emailVerfiy = baseURL + "email-verfiy";

export const calApproachesAPI = baseURL + "cal-approach";
export const customCalApproachesAPI = baseURL + "custom-cal-approach";
export const addCustomCalAPI = baseURL + "create-custom-cal-approach";
export const updateUnitAPI = baseURL + "target-setting-update-unit";

//Tracking Page
export const targetSetting = baseURL + "target-setting";
export const getSiteModule = baseURL + "companySetting";

//excelUpload
export const excelUpload = baseURL + "siteData/transportation-data";
export const getCompanyList = baseURL + "audit/companyList";
export const getV2CompanyVerification =
  baseURL + "v2/audit/companyVerification";
export const v2UpdateVerifyAction =
  baseURL + "v2/audit/updateAuditActionForVerify";

export const verificationApplicationAction =
  baseURL + "verificationApplicationAction";

export const getCheckAssetData = (assetId, unit) =>
  baseURL + `checkConsumption?assetId=${assetId}&unit=${unit}`;

export const createOrganizationSetUp = (params) =>
  baseURL +
  `organization/create-organization-set-up?companyId=${params.companyId}`;
// baseURL + `organization/create-organization-set-up?userId=${params.userId}`;

export const getEnergySourceList = (params) =>
  baseURL +
  `organization/get-energySource?activeDialog=${encodeURIComponent(params)}`;

export const getScheduleCompanyIdData = (params) =>
  baseURL + `schedule-list?companyId=${params}`;

export const getExcelEmissionActivityUsingPython = (params) =>
  baseURL + `v2/emissionview/get-excel-emissionActivity-using-python?activeDialog=${params.activeDialog}&companyId=${params.companyId}&language=${params.language}`;

export const uploadEAFileUsingPython = (cId,dialog,language) => baseURL + `v2/emissionview/upload-EA-using-python?cId=${cId}&dialog=${dialog}&language=${language}`;

export const getConsumptionDataByYear = (params) =>
  baseURL + `group/${params.groupId}/consumptionData?year=${params.year}`;

export const updateMultiConsumptionAPI = (year) =>
  baseURL + `asset/multiConsumptionData?year=${year}`;

export const getEmissionDataByYear = (params) =>
  baseURL + `group/${params.groupId}/emissionData?year=${params.year}`;

export const updateMultiEmissionAPI = (year) =>
  baseURL + `asset/multiEmissionData?year=${year}`;

export const getAssetUnit = (unit) =>
  baseURL + `conversionListByBaseUnit?baseUnit=${unit}`;

export const getAssetDataByUserId = baseURL + `company-assets-by-user`;
export const getAssetDataForUserId = baseURL + "company-assets-for-user";

export const updateAssetsData = (userId) =>
  baseURL + `asset/update-assets?userId=${userId}`;

export const getAnalysisReportAPI = (year, companyId) =>
  baseURL +
  `uncertaintyReport?year=${year}&userId=${
    companyId === 1 ? "All" : companyId
  }`;

export const getAnalysisReportByCompanyId = (
  selectedCompany,
  selectedLevel,
  selectedYear,
  selectionType
) =>
  baseURL +
  `analysisReport?year=${selectedYear}&companyId=${selectedCompany}&level=${selectedLevel}&selectionType=${selectionType}`;

export const deleteAssets = (companyId) =>
  baseURL + `delete-company-assets?companyId=${companyId}`;

export const companyFileUpload = baseURL + "company-file-upload";

export const reportFileUpload = baseURL + "report-file-upload";

export const reportFileList = () => baseURL + `report-file-list`;

export const companyFileList = (companyId) =>
  baseURL + `company-file-list?companyId=${companyId}`;

export const auditCompanyFileList = (companyId) =>
  baseURL + `audit-company-file-list?companyId=${companyId}`;

export const checkUploadFile = (id, fileName) =>
  baseURL + `asset/checkFileInAsset?assetFile=${id}&fileName=${fileName}`;

export const checkReportUploadFile = (id, fileName) =>
  baseURL + `checkReportFile?file=${id}&fileName=${fileName}`;

export const forceDeleteUploadFile = (id, fileName) =>
  baseURL + `asset/deleteFileInAsset?assetFile=${id}&fileName=${fileName}`;

export const forceDeleteReportUploadFile = (id, fileName) =>
  baseURL + `deleteReportFile?file=${id}&fileName=${fileName}`;

export const assignAssets = baseURL + "assign-assets";

export const getAllCompanies = baseURL + "get-companys";

export const getAllCompaniesV2 = baseURL + "audit/companyListv2";

export const getConsumptionData = (year, userId) =>
  baseURL + `asset/get-consumption-data?year=${year}&userId=${userId}`;

export const getEmissionData = (year, userId) =>
  baseURL + `asset/get-emission-data?year=${year}&userId=${userId}`;

export const getViewListsByCompany = (id, role) =>
  baseURL + `user-view-list?id=${id}&role=${role}`;

export const getUser = (id, role) =>
  baseURL + `user-detail?id=${id}&role=${role}`;

export const addConsumptionDataByYear = (year, companyId) =>
  baseURL +
  `v2/emissionview/add-data-entry?year=${year}&companyId=${companyId}`;

export const addConsumptionDataByYearWithExcel = (year, userId) =>
  baseURL +
  `v2/emissionview/add-data-entry-excel?year=${year}&userId=${userId}`;

export const addDataEntryByYearWithExcel = (year, companyId) =>
  baseURL +
  `v2/emissionview/add-data-entry-excel?year=${year}&companyId=${companyId}`;

export const addDataEntryByYear = (year, companyId) =>
  baseURL +
  `asset-management/add-data-entry?year=${year}&companyId=${companyId}`;

export const getScheduleData = () => baseURL + `asset/getRefreshScheduleData`;

export const updateConsumptionDataByYear = (year, companyId) =>
  baseURL +
  `v2/emissionview/update-data-entry?year=${year}&companyId=${companyId}`;
export const deleteConsumptionDataByYear = (year, companyId) =>
  baseURL + `asset/delete-consumption-data?year=${year}&companyId=${companyId}`;

export const getY2yAssetScopeEmissions = (scope, year, companyId, monthIndex) =>
  baseURL +
  `v2/y2yComparison/asset-scope-emissions?scope=${scope}&year=${year}&companylistId=${
    companyId === 1 ? "All" : companyId
  }&monthIndex=${monthIndex ? monthIndex : undefined}`;
export const getY2yAssetEnergy =
  baseURL + "y2yComparison/asset-energy-consumption";
export const getY2yAssetWater =
  baseURL + "y2yComparison/asset-water-consumption";

export const getReportDyEnergyComparison =
  baseURL + `dynamicReport/energy-comparison`;
export const getReportDyBaselineEmission = (
  url,
  selectedCompany,
  templateName,
  emissionUnit,
  selectedPeriod,
  templateLanguage,
  selectedLevel,
  selectedReportYear,
  subsidiaryUserId
) =>
  baseURL +
  url +
  `?userId=${selectedCompany}&templateName=${templateName}&emissionUnit=${emissionUnit}&selectedPeriod=${selectedPeriod}&templateLanguage=${templateLanguage}&selectedLevel=${selectedLevel}&reportYear=${selectedReportYear}&subsidiaryUserId=${subsidiaryUserId}`;
export const getReportDyGHGVerification =
  baseURL + `dynamicReport/getGHGVerification`;
export const getReportDyGHGEmissionAndTarget =
  baseURL + `dynamicReport/getGHGEmissionAndTarget`;
export const getReportDyAssetAndEmissionFactor =
  baseURL + `dynamicReport/assetAndEmissionFactor`;
export const getReportDyAnalysisGHGEmission = (year) =>
  baseURL + `dynamicReport/getAnalysisGHGEmission?year=${year}`;

export const getReportConfiguration = (companyId) =>
  baseURL + `get-company-templates?companyId=${companyId}`;
export const getDefaultTempNames = baseURL + `get-default-tempNames`;

export const getReportCustomConfig = (
  templateName,
  companyName,
  selectedPeriod,
  selectedReportYear
) =>
  baseURL +
  `all-custom-temps?templateName=${templateName}&companyName=${companyName}&reportingPeriod=${selectedPeriod}&reportingYear=${selectedReportYear}`;

export const editReportTemplate = baseURL + "modify-custom-temp";

export const createReportTemplate = baseURL + "create-custom-temp";

export const deleteReportTemplate = baseURL + "delete-custom-temp";

export const confirmSubmitTemplate = baseURL + "confirm-submit-custom-temp";

export const UpdateCustomCom = baseURL + "modify-custom-com";
export const DeleteCustomTempCom = baseURL + "delete-custom-temp-com";

// view summary

export const getAssetEmissionData = (assetId, userId) =>
  baseURL + `getAssetEmissionDataByAssetId?assetId=${assetId}&userId=${userId}`;

export const getAssetLinkedFile = (linkedFileId) =>
  baseURL + `asset/get-linked-file?linkedFileId=${linkedFileId}`;
export const findPageBykeyword = baseURL + "find-page-by-keyword";

export const getLogHistory = baseURL + "detail-log";

export const getTraceDetail = (logId, updatedId, updatedCategory) =>
  baseURL +
  `trace-log?logId=${logId}&updatedId=${updatedId}&updatedCategory=${updatedCategory}`;

export const getCompanySetupSelector = baseURL + "companySetupSelector";

export const addTargetSetting = baseURL + "add-target-setting";
export const getTargetSetting = baseURL + "get-target-setting";
// export const companySetupSelector = baseURL + "companySetupSelector";

export const addFeedback = baseURL + "add-feedback";

export const getFeedbackList = baseURL + "get-feedback-list";

export const getRating = (userId) =>
  baseURL + `getRatingOverview?userId=${userId}`;
export const getOrgBoundaryData = baseURL + "get-org-boundary-data";

export const addOrgBoundaryData = baseURL + "add-org-boundary-data";

export const updateOnBoardQuestions = (companyId) =>
  baseURL + `update-onboard-questions?companyId=${companyId}`;

export const getCustomOnBoardQuestions = (companyId) =>
  baseURL + `get-custom-onboard-questions?companyId=${companyId}`;

export const deleteChildCompany = baseURL + "delete-child-company";

export const addGHGCompanies = baseURL + "add-ghg-companies";

export const getOperationalRating = baseURL + "getRating";

export const addRatingData = baseURL + "add-rating-data";

export const getSelectedEnergySource = baseURL + `get-selected-energy-source`;

export const addCustomEmission = baseURL + `addCustomEmission`;

export const addVerifyStatus = baseURL + "change-verify-status";

export const fetchEmissionCalcuToolFile = baseURL + "urldownload";

export const fetchPCFFileDownload = baseURL + "pcfdownload";

export const getCustomEmissionFactorList =
  baseURL + "get-custom-emission-factors";

export const getCustomEmissionFactorCount =
  baseURL + "get-custom-emission-factor-count";

export const getAllChildCompanyCount = baseURL + "get-all-child-company-count";

export const getExpiryUserCount = baseURL + "get-expiry-user-count";

export const getAllChildCompanyList = baseURL + "get-all-child-companies";

export const getAllFacilityCompanyList = baseURL + "get-all-facility-companies";

export const getAllUserOperator = baseURL + "get-all-user-operator";

export const getVerificationPortal = (data) =>
  baseURL +
  `audit/verificationPortal?companyId=${data?.companyId}&scope=${data?.scope}&year=${data?.year}`;

// export const addEmissionDataByYear = (year, companyId) =>
//   baseURL + `asset/emission-data?year=${year}&companyId=${companyId}`;

export const addEmissionDataByYear = (year, companyId) =>
  baseURL +
  `v2/emissionview/add-emission-data?year=${year}&companyId=${companyId}`;

export const deleteEmissionDataByYear = (year, companyId) =>
  baseURL + `asset/delete-emission-data?year=${year}&companyId=${companyId}`;

export const deleteCustomEmissionFactorList = (customCalID, id, companyID) =>
  baseURL +
  `customEmissionDelete?customCalId=${customCalID}&id=${id}&companyId=${companyID}`;

export const getParentCompanyList = baseURL + "company_list";

export const getChildCompanies = (parentId) =>
  baseURL + `get-child-companies?parentId=${parentId}`;

export const addChildCompanies = baseURL + "add-child-companies";

export const updateChildCompany = baseURL + "update-child-company";
export const updateCompanySequence = baseURL + "update-company-sequence";

export const addTargetYear = baseURL + "add-target-year";

export const getAllRegion = baseURL + "get-all-regions";
export const getAllUserType = baseURL + "get-all-user-types";

// export const getEmissionReportData = baseURL + "get-direct-indirect-emission";
export const getEmissionReportData = (expandedBy) =>
  baseURL + `get-direct-indirect-emission?expandedBy=${expandedBy}`;

export const updateUserActive = (id, active) =>
  baseURL + `updateActiveUser?id=${id}&active=${active}`;

export const getSpecificReportsAPI = (year, company, monthIndex) =>
  baseURL +
  `specific/group-report/${year}?companylistId=${
    company === 1 ? "All" : company
  }&monthIndex=${monthIndex ? monthIndex + 1 : undefined}`;

export const getModuleList = baseURL + "get-modules";

export const addNewModules = baseURL + "add-modules";

export const getYTDScopeData = (companyId, year, month, quarter, aggregate) =>
  baseURL +
  `v2/dashboard/get-ytd-emission-summary?companyId=${companyId}&aggregate=${aggregate}&year=${year}${
    month ? "&month=" + month : ""
  }${quarter ? "&quarter=" + quarter : ""}`;

export const getNetZeroList = (year, period, aggregate) =>
  baseURL +
  `v2/dashboard/get-my-net-zero-roadmap?aggregate=${aggregate}&year=${year}&filter=${period}`;

export const getNetZeroFilter = (year, period, aggregate, month) =>
  baseURL +
  `v2/dashboard/get-my-net-zero-roadmap?aggregate=${aggregate}&year=${year}&filter=${period}&month=${month}`;

export const getEmissionHotspots = (
  companyId,
  year,
  month,
  quarter,
  aggregate
) =>
  baseURL +
  `v2/dashboard/get-emission-hostpots?companyId=${companyId}&aggregate=${aggregate}&year=${year}${
    month ? "&month=" + month : ""
  }${quarter ? "&quarter=" + quarter : ""}`;

export const getEmissionByCountry = (
  companyId,
  year,
  month,
  quarter,
  aggregate
) =>
  baseURL +
  `v2/dashboard/get-total-emission-by-location?companyId=${companyId}&aggregate=${aggregate}&year=${year}${
    month ? "&month=" + month : ""
  }${quarter ? "&quarter=" + quarter : ""}`;

export const getEmissionBySubsidiary = (
  companyId,
  year,
  month,
  quarter,
  aggregate
) =>
  baseURL +
  `v2/dashboard/get-total-emission-by-subsidiary?companyId=${companyId}&aggregate=${aggregate}&year=${year}${
    month ? "&month=" + month : ""
  }${quarter ? "&quarter=" + quarter : ""}`;

export const getEmissionByFacility = (
  companyId,
  year,
  month,
  quarter,
  aggregate
) =>
  baseURL +
  `v2/dashboard/get-total-emission-by-facility?companyId=${companyId}&aggregate=${aggregate}&year=${year}${
    month ? "&month=" + month : ""
  }${quarter ? "&quarter=" + quarter : ""}`;

export const getHeirarchyData = baseURL + "v2/onboardinfo/get-heirarchy-data";

export const addFacility = baseURL + "v2/onboardinfo/add-facility";

export const getAuditYearsByCompany = (companyId) =>
  baseURL +
  `v2/emissionview/get-audit-verification-year?companyId=${companyId}`;

export const checkForAuditRequest = (userId, year) =>
  baseURL +
  `v2/emissionview/check-for-audit-request?userId=${userId}&year=${year}`;

export const getNonDeletableAssets = (userId) =>
  baseURL + `v2/emissionview/get-non-deletable-assets?userId=${userId}`;

export const getAllTranslations = baseURL + "translation/get-all-translations";
export const translationUrl = (lng, ns) => baseURL + `translation/${lng}/${ns}`;
export const addNewTranslations = (lng, ns) =>
  baseURL + `translation/add-new-translations/${lng}/${ns}`;
export const createParentCompany =
  baseURL + `v2/usermanagement/create-parent-company`;

export const createFacilityCompany =
  baseURL + `v2/usermanagement/create-facility-company`;

  export const getCalApproachesList = (
    page,
    rowPerPage,
    selectedSource,
    selectedYear,
    selectedScope,
    selectedCategory,
    searchQuery,
  ) => {
    const params = new URLSearchParams({
      page,
      rowPerPage,
      selectedSource,
      selectedYear,
      selectedScope,
      selectedCategory,
      searchQuery,
      selectedLanguage: common.language
    });
  
    return `${baseURL}v2/get-emission-factor-management-list/python?${params.toString()}`;
  };

export const getDbInventory = () => baseURL + `get-database-inventory`;

export const downloadDefaultTemplate = (file) =>
  baseURL + `download-excel?file=${file}`;

export const uploadEmissionFactorFile = () =>
  baseURL + `post-emission-factor-management-list`;

export const fetchOrganizationList =
  baseURL + "v2/emissionview/get-organization-list";

export const getAllCompanyAssets = (selectedCompanyId, companyLevel) =>
  baseURL +
  `v2/emissionview/get-all-company-assets?companyId=${selectedCompanyId}&level=${companyLevel}`;

export const createEmissionActivity = (companyId) =>
  baseURL + `v2/emissionview/create-emission-activity?companyId=${companyId}`;

export const createEmissionActivityV2 = (companyId) =>
  baseURL + `v2/emissionviewV2/create-emission-activity?companyId=${companyId}`;

// export const getAllConsumptionData = (companyId, level, year) => baseURL +  `v2/emissionview/get-all-consumption-data?companyId=${companyId}&level=${level}&year=${year}`;
export const getAllConsumptionData = (companyId, level, year) =>
  baseURL +
  `v2/emissionview/get-all-consumption-data?companyId=${companyId}&level=${level}&year=${year}`;

export const getAllEmissionData = (companyId, level, year) =>
  baseURL +
  `v2/emissionview/get-all-emission-data?companyId=${companyId}&level=${level}&year=${year}`;

export const getAllActivityData = () =>
  baseURL + `v2/emissionview/get-all-activity-names`;

export const getAllUnits = baseURL + "v2/emissionview/get-all-units";

export const updateEmissionActivity = (companyId) =>
  baseURL + `v2/emissionview/update-emission-activity?companyId=${companyId}`;

export const updateEmissionActivityV2 = (companyId) =>
  baseURL + `v2/emissionviewV2/update-emission-activity?companyId=${companyId}`;

export const getCustomEmissionFactors = (data) =>
  baseURL +
  `get-custom-ef-list?companyId=${data.companyId}&scope=${
    data.scope
  }&category=${encodeURIComponent(data.category)}`;
export const getConsumptionDataByPeriodRange = (
  cId,
  selectedStartDate,
  selectedEndDate
) =>
  baseURL +
  `asset/get-consumption-data-by-period?companyId=${cId}&level=facility&start_date=${selectedStartDate}&end_date=${selectedEndDate}`;

export const AddDvApplicationData = baseURL + "add-dv-application";

export const addReportFile = baseURL + "add-report-file";

export const submitDefaultReport = baseURL + "submit-default-report";

export const getAllDvApplications = (userId) =>
  baseURL + `get-all-dv-applications?userId=${userId}`;

export const getSpecificDvApplication = (id, role) =>
  baseURL + `get-specific-dv-application?id=${id}&view=${role}`;

export const revertApplicationRequest = (id) =>
  baseURL + `withdraw-application-request?id=${id}`;

export const rejectApplicationRequest = (id) =>
  baseURL + `reject-application-request?id=${id}`;

export const downloadCustomReport = (
  reportFileList,
  selectedFile,
  applicationId
) =>
  baseURL +
  `download-custom-report?fileName=${reportFileList}&fileId=${selectedFile}&applicationId=${applicationId}`;

//PCF
export const createProduct = baseURL + `v2/products/create`;

export const updateProduct = (productId) =>
  baseURL + `v2/products/update/${productId}`;

export const getAllProducts = baseURL + `v2/products`;

export const getAllPCFEmissionSourceByCompany =
  baseURL + `v2/emission-source-by-company`;

export const downloadGHGExcel = baseURL + "generate-GHG-Excel-py";

// export const createProductData = baseURL + "v2/pcf-data/create";
export const SavePCFData = API("v2/pcf/pcf-data");

export const getOneProduct = (productId) =>
  baseURL + `v2/products/${productId}`;

export const deleteProduct = (productId) =>
  baseURL + `v2/products/delete/${productId}`;

// export const getOneProductData = (productId) =>
//   baseURL + `v2/pcf-data/${productId}`;

// export const getAllPCFUnits = baseURL + "v2/get-pcf-emission-factors";
export const GetEmissionFactorsAndConversionUnits = API(
  "v2/pcf/emission-factors-and-conversion-units"
);

// export const getAllPCFEmissions = baseURL + "v2/pcfEmissionFactors";
export const GetPCFEmissionFactors = API("v2/pcf/emission-factors");

//emission factor

export const createEmissionSource = baseURL + `v2/emission-source/create`;

export const createUnitType = baseURL + `v2/unit-types/create`;

export const updateSequenceByES =
  baseURL + `v2/emission-source/update-sequence`;

export const createEmissionType = baseURL + `v2/emission-types/create`;

export const getEmissionSource = baseURL + `v2/emission-source`;

export const getUnitType = baseURL + `v2/unit-types`;

export const getEmissionType = baseURL + `v2/emission-types`;

export const createEmissionFactor = baseURL + `v2/custom-pcfFactors/create`;

export const deleteEmissionFactor = () =>
  baseURL + `v2/pcfEmissionFactors/delete`;

//release notes
export const createReleaseNote = baseURL + "v2/releaseNotes/create-releaseNote";

export const getReleaseNotes = baseURL + "v2/releaseNotes/get-releaseNotes";

export const updateReleaseNote = (userId, editNoteId) =>
  baseURL +
  `v2/releaseNotes/update-releaseNote?userId=${userId}&releaseNoteId=${editNoteId}`;

export const deleteReleaseNote = (releaseNoteId) =>
  baseURL + `v2/releaseNotes/delete-releaseNote/${releaseNoteId}`;

export const downloadCustomEFUsingPython = (cId) => baseURL + `download-custom-EF-using-python?cId=${cId}`;

export const uploadCustomEFFileUsingPython = (cId) => baseURL + `upload-custom-EF-using-python?cId=${cId}`;

export const sendReleaseNote = baseURL + "v2/releaseNotes/send-releaseNote";

export const getAllEmissionActivityDataForCategory = (category,companyId) => baseURL + `v2/emissionview/get-ef-python?category=${category}&cid=${companyId}`

export const getDefaultEmissionActivityDataForCategory = (type,category,companyId) => baseURL + `v2/emissionview/get-ef-python?type=${type}&cid=${companyId}&category=${category}`

//ctbc

export const saveDraftNewProject = (type) =>
  baseURL + `v2/ctbc/save-draft?type=${type}`;

export const getSaveDraftData = () => baseURL + `v2/ctbc/save-draft`;

export const getAllNewProject = baseURL + `v2/ctbc/save-draft`;

export const saveCarbonNeutralPlanning =
  baseURL + `v2/ctbc/carbon-neutral-planning`;

export const getCTBCLocation = baseURL + `v2/ctbc/get-location`;

export const deleteLisOfProject = (id) =>
  baseURL + `v2/ctbc/delete-project?id=${id}`;

export const getAllProjects = baseURL + `v2/ctbc/get-projects`;

export const saveNewProject = baseURL + `v2/ctbc/save-project`;

export const editProject = (id) => baseURL + `v2/ctbc/edit-project?id=${id}`;

export const deleteCTBCDraft = baseURL + `v2/ctbc/delete-draft`;
